import { render, staticRenderFns } from "./OrderFoodExportReport.vue?vue&type=template&id=6dd0bafc&scoped=true"
import script from "./OrderFoodExportReport.vue?vue&type=script&lang=js"
export * from "./OrderFoodExportReport.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodExportReport.vue?vue&type=style&index=0&id=6dd0bafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd0bafc",
  null
  
)

export default component.exports